import albaniaFlagPicture from "./albania-flag.png";
import owlPicture from "./owl.png";
import cookiePicture from "./cookie.png";
import worldMapPicture from "./world-map.png";
import snowMountainPicture from "./snow-mountain.png";
import horseRacingPicture from "./horse-racing.png";
import {IPictureItem} from "../types/pictures";

const PICTURES: IPictureItem[] = [
  {id: 0, pictureSrc: albaniaFlagPicture},
  {id: 1, pictureSrc: owlPicture},
  {id: 2, pictureSrc: cookiePicture},
  {id: 3, pictureSrc: worldMapPicture},
  {id: 4, pictureSrc: snowMountainPicture},
  {id: 5, pictureSrc: horseRacingPicture},
];

export default PICTURES;
